import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { DatafoxDevice } from '../../../models/datafox-device.model';
import { TerminalsService } from '../../../services/terminals.service';

@Component({
    selector: 'terminal-list',
    templateUrl: './terminal-list.component.html',
    styleUrls: ['./terminal-list.component.scss'],
    standalone: false
})
export class TerminalListComponent implements AfterViewInit, OnDestroy {

  @Input() showDetails: boolean = true;

  public displayedColumns = ['type', 'serialNumber', 'name', 'shop', 'firmware', 'status'];
  public tabledata: MatTableDataSource<DatafoxDevice>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  public terminalsListUnfiltered: Array<DatafoxDevice> = new Array<DatafoxDevice>();

  public terminalsListChangedSubscription: Subscription;

  constructor(private terminalsService: TerminalsService, private router: Router,
    private cdr: ChangeDetectorRef) {

    this.terminalsListChangedSubscription = this.terminalsService.allTerminalsChanged
      .pipe(filter(terminals => !!terminals))
      .subscribe(terminals => {
        this.updateListData(terminals);
    });
  }

  ngAfterViewInit(): void {
    if (!this.showDetails) {
      this.displayedColumns = ['type', 'serialNumber', 'status'];
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    if (this.terminalsListChangedSubscription) {
      this.terminalsListChangedSubscription.unsubscribe();
    }
  }

  public get terminalsSearchList() {
    return this.terminalsService.terminalsSearchList;
  }

  public set terminalsSearchList(values: DatafoxDevice[]) {
    this.terminalsService.terminalsSearchList = values;
  }

  private updateListData(terminals: DatafoxDevice[]) {
    if (this.searchTerm) {
      // console.log('search active => ', this.searchTerm);
      let delTerminals = new Array<DatafoxDevice>();
      // Update von den gefilterten Terminals
      for (let i = 0; i < this.terminalsSearchList.length; i++) {
        let find = terminals.find(x => x.serialNumber == this.terminalsSearchList[i].serialNumber);
        if (find) {
          this.terminalsSearchList[i] = find;
        } else {
          delTerminals.push(this.terminalsSearchList[i]);
        }
      }
      for (let delTerminal of delTerminals) {
        let index = this.terminalsSearchList.indexOf(delTerminal);
        if (index > -1) {
          this.terminalsSearchList.splice(index, 1);
        }
      }

    } else {
      // Alle Terminals aktualisieren
      // console.log('search empty ###');
      this.terminalsSearchList = terminals;
    }
    this.terminalsListUnfiltered = terminals;
    this.initializeTable();
  }

  private initializeTable() {
    this.tabledata = new MatTableDataSource(this.terminalsSearchList);
    this.tabledata.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'shop': return item.shop?.name;
        case 'firmware': return item.firmwareVersion;
        default: return item[property];
      }
    }
    this.tabledata.sort = this.sort;
  }

  public get isTerminalLinkDisabled() {
    if (this.terminalsService) {
      return this.terminalsService.isTerminalLinkDisabled();
    }
    return true;
  }

  public selectTerminalFromList(terminal: DatafoxDevice, event) {
    this.terminalsService.selectUserFromList(terminal, event);
  }

  public openDetails(terminal: DatafoxDevice, event: any) {
    var path = event.path || (event.composedPath && event.composedPath()) || this.composedPath(event.target);

    if (path && (path[1].localName != "is-used-button")) {
      this.router.navigate(['/terminals/', terminal.deviceType, terminal.serialNumber]);
    }
  }

  // Search
  public searchTerm: string = "";

  search(): void {
    this.terminalsSearchList = this.terminalsListUnfiltered;
    let term = this.searchTerm.replace(/\s/g, "").toLowerCase();
    this.terminalsSearchList = this.terminalsListUnfiltered.filter(function (tag) {
      return (tag?.name?.toLowerCase().indexOf(term) >= 0) || (tag?.deviceType?.toLowerCase().indexOf(term) >= 0)
        || (tag?.serialNumber?.toLowerCase().indexOf(term) >= 0) || (tag?.shop?.name.toLowerCase().indexOf(term) >= 0)
        || (tag?.firmwareVersion?.toLowerCase().indexOf(term) >= 0);
    });

    this.initializeTable();
  }

  private composedPath(el) {
    var path = [];
    while (el) {
      path.push(el);
      if (el.tagName === 'HTML') {
        path.push(document);
        path.push(window);
        return path;
      }

      el = el.parentElement;
    }
  }

  public isActive(terminal: DatafoxDevice): boolean {
    if (terminal && this.terminalsService?.getSelectedModel()) {
      let selected = this.terminalsService.getSelectedModel();
      return selected.serialNumber == terminal.serialNumber && selected.deviceType == terminal.deviceType;
    }

    return false;
  }

  public trackByIndex(i: number) {
    return i;
  }
}
